import { Component, OnInit } from '@angular/core';

import { version } from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'face-recognition';

  ngOnInit() {
    this.printVersion();
  }

  private printVersion() {
    const commonStyles = 'background: #1d1f25; font-size: 14px';
    console.log(
      `%cULTRA%cIP %c${version}`,
      `${commonStyles}; color: #fff`,
      `${commonStyles}; color: #c1150a`,
      `${commonStyles}; color: #fff`
    );
  }
}
